export const CHANGE_MONTHLY_START = 'change-monthly-start';
const changeMonthlyStart = ({ monthlyStart }) => ({ type: CHANGE_MONTHLY_START, payload: { monthlyStart } });
export default changeMonthlyStart;
